
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_VERSION;

// Types de cadeaux pour les filtres : tous les types de la table pour les rôles 1 et 2, les groupes pour le rôle 3
export const fetchGiftTypes = async (user) => {

  try {
    const response = await axios.get(`${API_BASE_URL}/gifts/types`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user}`
      }
    });

    return response.data;

  } catch (err) {

    console.log(err)
    return []
  }

}

export const fetchGift = async (user, page, limit, filters, startDate, endDate, search) => {

  try {
    const filterString = filters.map(filter => `&filters%5B%5D=${encodeURIComponent(filter)}`).join('');
    const searchStr = search ? `&search=${search}` : '';
    const url = `${API_BASE_URL}/gifts/list?startDate=${startDate}&endDate=${endDate}${filterString}&page=${page}&limit=${limit}${searchStr}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user}`
      }
    });

    return response.data;

  } catch (err) {

    console.log(err)
  }

}


export const assignGift = async (user, userUuid, tickerUuid, amount, type, isMoneyGift) => {

  try {
    await axios.post(API_BASE_URL + '/gifts/assign', {
      userUuid,
      tickerUuid,
      amount,
      type,
      isMoneyGift
    }, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user}`
      }
    })
  } catch (e) {
    throw e
  }

}
